import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import DualActionButtons from '../action_button/DualActionButtons'
import {
  dialogActionsSx,
  dialogBodyTextSx,
  dialogContentSx,
  dialogDividerSx,
  dialogHeaderSx,
  dialogTitleSx,
  getDialogCancelAction,
  getDialogPaperSx
} from '../../constants/dialogSx'
import { UI_COLOR_PRIMARY, UI_COLOR_PRIMARY_HOVER } from '../../constants/uiColors'

const dialogPaperSx = getDialogPaperSx(520)

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancelar',
  confirmColor = UI_COLOR_PRIMARY,
  confirmHoverColor = UI_COLOR_PRIMARY_HOVER,
  disableClose = false,
  onClose,
  onConfirm,
  onExited,
  titleId = 'confirm-dialog-title'
}) {
  return (
    <Dialog
      open={open}
      onClose={disableClose ? undefined : onClose}
      disableEscapeKeyDown={disableClose}
      TransitionProps={onExited ? { onExited } : undefined}
      fullWidth
      maxWidth={false}
      aria-labelledby={titleId}
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle sx={dialogHeaderSx}>
        <Typography id={titleId} component="span" sx={dialogTitleSx}>
          {title}
        </Typography>
      </DialogTitle>
      <Divider sx={dialogDividerSx} />
      <DialogContent sx={dialogContentSx}>
        {message ? <Typography sx={dialogBodyTextSx}>{message}</Typography> : null}
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        <DualActionButtons
          fullWidthOnMobile={false}
          minWidth={112}
          gap={1}
          secondaryAction={getDialogCancelAction({
            label: cancelLabel,
            onClick: onClose
          })}
          primaryAction={{
            label: confirmLabel,
            icon: null,
            color: confirmColor,
            hoverColor: confirmHoverColor,
            onClick: onConfirm
          }}
        />
      </DialogActions>
    </Dialog>
  )
}
